module.exports = __webpack_public_path__ + "img/norecordspan.a4238381.svg";